import React, { useContext } from 'react';
import { Toast } from '@womcorp/wom-miwom-ui-kit/dist/components/Toast';
import ToastContext from '../../contextProvider/ToastContext';
import AppContext from './AppContext';

const AppToast = () => {
  const { toastProps, setToastProps } = useContext(ToastContext);
  const { showNavbar } = useContext(AppContext);

  return (
    <Toast
      open={!!toastProps}
      onClose={() => setToastProps(null)}
      message={toastProps?.message ?? ''}
      variant={toastProps?.variant ?? 'info'}
      autoHideDuration={toastProps?.autoHideDuration ?? 3000}
      anchorOrigin={toastProps?.anchorOrigin || undefined}
      sx={{ bottom: showNavbar ? '100px' : '8px' }}
    />
  );
};

export default AppToast;
